export const getCookiesAsObject = () => (
    Object.fromEntries(document.cookie.split(/; */).map(c => {
        const [key, ...v] = c.split('=');
        return [key, decodeURIComponent(v.join('='))];
    }))
);
